export default __webpack_public_path__ + "static/media/Jack&Jones.774fbf2d.jpeg";